import { DIFFERENCE_CONSTANTS } from "./constants";
import { Box, Heading, SimpleGrid } from "@chakra-ui/react";
import PageLayout from "@/layouts/pageLayout";
import bgImage from "public/openStack/diffrenceBG.png";
import { AdvantageCard } from "@/components/advantageCard";

const DifferenceComponent = () => {
  return (
    <Box bgImage={`url(${bgImage.src})`} bgSize="cover" pb={20}>
      <PageLayout>
        <Box>
          <Heading
            as="h2"
            fontWeight={"400"}
            textAlign={"center"}
            fontSize={"40px"}
            color="white"
            mb={7}
          >
            What Makes Us Different?
          </Heading>
          <SimpleGrid columns={{ base: 1, md: 3 }} gap={12} width={"100%"}>
            {DIFFERENCE_CONSTANTS.map((item, index) => (
              <AdvantageCard
                key={index}
                text={item.text}
                image={item.image}
                title={item.title}
                textColor={"white"}
                headingColor={"white"}
                alignDirection="center"
              />
            ))}
          </SimpleGrid>
        </Box>
      </PageLayout>
    </Box>
  );
};

export default DifferenceComponent;
